// import React, { useState, useEffect } from "react";
import React, { useState, useEffect, useRef } from "react";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";
import Swal from "sweetalert2";

import Quill from "quill";
import "quill/dist/quill.snow.css";



import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// import "./fonts/NotoSansMalayalam-Regular-normal";

import { Editor } from "@tinymce/tinymce-react";

export default function HomePage() {
  const [open, setOpen] = useState(true);

  // Sidebar auto collapse
  useEffect(() => {
    const handleResize = () => {
      setOpen(window.innerWidth >= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [formData, setFormData] = useState({
    details: ""
  });

  const [editId, setEditId] = useState(null);

  const fetchLatest = async () => {
    try {
      const res = await fetch("http://login.abhedasramam.org/get_home.php");
      const data = await res.json();

      if (data && data.details) {
        setFormData({ details: data.details });
        setEditId(data.id);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchLatest();
  }, []);

  const handleSave = async () => {
    try {
      const res = await fetch("http://localhost/your-folder/save_home.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          details: formData.details,
          remark: ""
        }),
      });

      const data = await res.json();

      if (data.status === "success") {
        Swal.fire("Success", "Saved successfully", "success");
        fetchLatest(); // reload
      } else {
        Swal.fire("Error", data.message, "error");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const editorRef = useRef(null);
  const quillRef = useRef(null);

  useEffect(() => {
    if (!quillRef.current) {
      quillRef.current = new Quill(editorRef.current, {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link"],
            [{ align: [] }]
          ]
        }
      });

      // Load existing data
      quillRef.current.root.innerHTML = formData.prescription || "";

      // Save on change
      quillRef.current.on("text-change", () => {
        const html = quillRef.current.root.innerHTML;
        setFormData((prev) => ({ ...prev, prescription: html }));
      });
    }
  }, []);

  return (
    <div className="container-fluid p-0">
      <div className="d-flex" style={{ height: "100vh" }}>
        <div
          className="top-0 start-0 p-2 fs-3 rounded shadow-sm"
          style={{
            zIndex: 999,
            cursor: "pointer",
            position: "fixed",
            left: open ? "350px" : "60px",
            top: "0",
            transition: "left 0.3s ease"
          }}
          onClick={() => setOpen(!open)}
        >
          <span className="displaysidemenu" style={{ position: "absolute", right: "-10px" }}>
            ☰
          </span>
        </div>
        <div
          className="border-end leftcolor"
          style={{
            width: open ? "350px" : "0",
            overflow: "hidden",
            transition: "0.3s ease"
          }}
        >
          {open && (
            <div className="p-3">
              <AdminLeft />
            </div>
          )}
        </div>

        {/* RIGHT CONTENT */}
        <div
          className="p-4"
          style={{
            width: open ? "calc(100% - 350px)" : "100%",
            transition: "0.3s ease",
            paddingLeft: "30px"
          }}
        >
          <TopBanner />
          <div className="area mt-4" >
            <h2></h2>

            {/* Inputs */}


            {/* TABLE (only after search) */}
            <div style={{ height: '70vh', overflow: 'auto' }}>
              <input
                placeholder="Remarks"
                name="prescription"
                // value={formData.prescription}
                // onChange={handleEntryChange}
                className="form-control mt-2" style={{ display: 'none' }}
              />


              {/* <Editor
                apiKey="vwc2250gw344g249up4k201omsyv5ahfny97oil1nr6f1i1p" // works free
                value={formData.details}
                init={{
                  height: 450,
                  menubar: false,
                  plugins: ["lists", "link", "preview"],
                  toolbar: 'undo redo | tinymceai-chat tinymceai-quickactions tinymceai-review | blocks fontfamily fontsize | bold italic underline strikethrough | link media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography uploadcare | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                }}
                onEditorChange={(content) =>
                  setFormData({ ...formData, details: content }) // ✅ important
                }
              /> */}

              <div ref={editorRef} style={{ height: "400px" }} />
              <div className="mt-3">
                {/* <button className="btn btn-warning w-50 mb-2 mr-1" onClick={handleSave}> */}
                <button className="btn btn-warning w-50 mb-2 mr-1">
                  Save
                  {/* {editId ? "Update" : "Save"} */}
                </button>
                {/* <button className="btn btn-secondary w-30 mb-2" onClick={handleCancel}> */}
                <button className="btn btn-secondary w-30 mb-2" >
                  Cancel
                </button>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  );
}